export default {
  name: "dr-round-button",
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  computed: {
    inputListeners: function() {
      var vm = this;

      return Object.assign({}, this.$listeners, {
        input: function(event) {
          vm.$emit("input", event.target.value);
        }
      });
    }
  }
};
